import { TriangleAlertIcon } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useT } from "@/glossary";
import { cn } from "@/lib/cn";
import { RESERVED_USERNAMES, saveUsername } from "@/lib/stores/user-prefs";

const isFirefox = navigator.userAgent.includes("Firefox");

export const Onboarding = () => {
  const t = useT();
  const [username, setUsername] = useState("");
  const [firefoxAck, setFirefoxAck] = useState(false);

  const missingUsername = !username.trim();
  const isReserved = RESERVED_USERNAMES.includes(username.trim());
  const missingFirefoxAck = isFirefox && !firefoxAck;
  const canSubmit = !missingUsername && !isReserved && !missingFirefoxAck;

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-8 p-4">
      <h1 className="font-bold text-2xl">{t.onboarding.welcome}</h1>
      <div className="flex w-full max-w-xs flex-col gap-6">
        <div className="flex flex-col gap-2">
          <label htmlFor="username" className="text-muted-foreground">
            {t.onboarding.yourName}
          </label>
          <input
            id="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            maxLength={50}
            placeholder={t.onboarding.enterYourName}
            className="rounded border border-foreground bg-background px-4 py-2"
          />
          <p
            className={cn(
              "text-destructive text-sm",
              !isReserved && "invisible",
            )}
          >
            {t.onboarding.nameReserved}
          </p>
        </div>

        {isFirefox && (
          <div className="flex flex-col items-center gap-3 rounded-lg border-2 border-red-500 bg-red-500/15 p-4 text-center">
            <TriangleAlertIcon className="size-8 animate-[pulse-warning_1s_ease-in-out_infinite] text-red-500" />
            <p className="font-semibold text-red-600 text-sm dark:text-red-400">
              {t.common.firefoxWarning}
            </p>
            <label className="flex cursor-pointer items-center gap-2 text-sm">
              <input
                type="checkbox"
                checked={firefoxAck}
                onChange={(e) => setFirefoxAck(e.target.checked)}
                className="size-4 accent-red-500"
              />
              <span className="text-red-600 dark:text-red-400">
                {t.onboarding.firefoxAck}
              </span>
            </label>
          </div>
        )}

        <Button
          aria-disabled={!canSubmit}
          onClick={() => {
            if (missingUsername) return toast.error(t.onboarding.enterYourName);
            if (isReserved) return toast.error(t.onboarding.nameReserved);
            if (missingFirefoxAck)
              return toast.error(t.onboarding.firefoxAckRequired);
            saveUsername(username.trim());
          }}
        >
          {t.common.continue}
        </Button>
      </div>
    </div>
  );
};
